export default "__VITE_ASSET__fa5c8dab__"